// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Đọc file ngôn ngữ từ các thư mục locales
import viTranslation from './vi.json';
import enTranslation from './en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next) 
  .init({
    fallbackLng: 'vi',
    debug: false,
    interpolation: {
      escapeValue: false, 
    },
    react: {
      useSuspense: false,
    },
    resources: {
      vi: {
        translation: viTranslation, 
      },
      en: {
        translation: enTranslation,
      }
    },
    lng: localStorage.getItem('language') || 'vi', 
  });

export default i18n;
